/*------------------------------------*\
	#FORM CONTROL SELECTION
\*------------------------------------*/

window.onload = function () {
	if (document.querySelector('.js-termination')) {
		formControlSelect();
	}
};

function formControlSelect() {
	let terminationdate = document.querySelector('.js-terminationdate'),
		terminationnow = document.querySelector('.js-terminationnow'),
		terminationfieldset = document.querySelector('.js-terminationfieldset'),
		terminationproper = document.querySelector('.js-terminationproper'),
		terminationproperselect = document.querySelector('.js-terminationproperselect'),
		terminationexceeding = document.querySelector('.js-terminationexceeding'),
		terminationexceedingselect = document.querySelector('.js-terminationexceedingselect'),
		terminationtype = document.querySelector('.js-terminationtype'),
		terminationother = document.querySelector('.js-terminationother'),
		prev = null;

	formControlSelectProper(terminationproper, terminationexceeding, terminationfieldset, terminationexceedingselect, terminationdate, terminationnow, terminationother)

	terminationtype.addEventListener("click", function () {
		var options = terminationtype.querySelectorAll("option");
	});

	terminationtype.addEventListener("change", function () {
		if (terminationtype.value === "proper") {
			formControlSelectProper(terminationproper, terminationexceeding, terminationfieldset, terminationexceedingselect, terminationdate, terminationnow, terminationother);
		} else {
			formControlSelectExceeding(terminationproper, terminationexceeding, terminationfieldset, terminationexceedingselect, terminationdate, terminationnow, terminationother);
		}
	});

	terminationexceedingselect.addEventListener("change", function () {
		if (terminationexceedingselect.value === "umzug") {
			terminationfieldset.style.display = 'block';
			terminationdate.setAttribute("required", "required");
			terminationnow.setAttribute("required", "required");
		} else {
			terminationfieldset.style.display = 'none';
			terminationdate.removeAttribute("required");
			terminationnow.removeAttribute("required");
		}
	});

	terminationproperselect.addEventListener("change", function () {
		if (terminationproperselect.value === "sonstige") {
			terminationother.style.display = 'block';
		} else {
			terminationother.style.display = 'none';
		}
	});


	terminationdate.addEventListener("change", function () {
		if (terminationdate.value === "") {
			terminationnow.setAttribute("required", "required");
		} else {
			terminationnow.removeAttribute("required");
			terminationnowspan = terminationnow.parentNode.querySelector(".required");
			terminationnow.parentNode.removeChild(terminationnowspan);

		}
	});

	terminationnow.addEventListener("change", function () {
		if (terminationnow.checked === true) {
			terminationdate.removeAttribute("required");
		} else {
			terminationdate.setAttribute("required", "required");
		}
	});

}

function formControlSelectProper(terminationproper, terminationexceeding, terminationfieldset, terminationexceedingselect, terminationdate, terminationnow, terminationother) {
	terminationexceeding.style.display = 'none';
	terminationother.style.display = 'none';
	terminationproper.style.display = 'block';
	terminationfieldset.style.display = 'block';
	terminationexceedingselect.removeAttribute("required");
	terminationdate.setAttribute("required", "required");
	let todayDate = new Date().toISOString().slice(0, 10);
	terminationdate.setAttribute("min", todayDate);
	terminationnow.setAttribute("required", "required");
}

function formControlSelectExceeding(terminationproper, terminationexceeding, terminationfieldset, terminationexceedingselect, terminationdate, terminationnow, terminationother) {
	terminationproper.style.display = 'none';
	terminationother.style.display = 'none';
	terminationexceeding.style.display = 'block';
	terminationfieldset.style.display = 'none';
	terminationexceedingselect.setAttribute("required", "required");
	terminationdate.removeAttribute("required");
	terminationnow.removeAttribute("required");
}
